import {
    boxClassName,
    pxArrayToRem,
    pxToRem,
    tileImageClassName,
    tileImageSlotClassNames,
    tileOverlayClassName,
    tileOverlaySlotClassNames,
    flexClassName,
    checkboxSlotClassNames,
    projectTileClassName,
    productTileClassName,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { checkboxClassName } from '@fluentui/react-northstar';
import { PinTilesDesktop } from '~/modules/design-board/component/all-pins/PinTiles.desktop.style';
import { PinTilesMobile } from '~/modules/design-board/component/all-pins/PinTiles.mobile.style';

export const PinTile: StyleRule<{ checked?: boolean }> = ({
    theme,
    checked,
}) => {
    return {
        [`& .${tileImageClassName}`]: {
            width: '100%',
            [`& .${tileImageSlotClassNames.imageContainer}`]: {
                height: '100%',
                width: '100%',
            },
        },

        // Other styles on the tileOverlay icons goes here: shared/TileTopAction.style.tsx
        [`& .${tileOverlaySlotClassNames.topActions}`]: {
            pointerEvents: 'all',
            width: '100%',
            [`& > .${boxClassName}`]: {
                width: '100%',
                [`& > .${flexClassName}`]: {
                    width: '100%',
                    justifyContent: 'flex-end',
                },
            },
        },
        [`& .${tileOverlayClassName}`]: {
            alignItems: 'flex-start',
            width: '100%',
            padding: 0,
            ...(checked && {
                opacity: 1,
            }),
        },

        '& .pin-tile': {
            padding: 0,
        },

        [`& .${productTileClassName} .${tileImageSlotClassNames.imageContainer}`]:
            {
                backgroundColor: theme.siteVariables.colors.white['200A'],
                [`& img`]: {
                    mixBlendMode: 'multiply',
                },
            },

        [theme.screen.tablet]: {
            '& .pin-tile': {
                width: '100%',
            },
        },

        [theme.screen.laptop]: {
            '& .pin-tile .ui-tileOverlay': {
                [`& .${checkboxSlotClassNames.indicatorContainer} .${svgIconClassName}`]:
                    {
                        height: pxToRem(16),
                        width: pxToRem(16),
                    },
                [`& .${checkboxClassName}`]: {
                    ...(checked && {
                        opacity: 1,
                    }),
                },
            },

            [`& .${projectTileClassName} .${tileOverlayClassName} .${svgIconClassName}`]:
                {
                    width: pxToRem(16),
                },

            [`& .board-tile-overlay`]: {
                opacity: 0,
            },
            '&:hover': {
                [`& .board-tile-overlay`]: {
                    opacity: 1,
                },
                [`& #ShoppingAvailable`]: {
                    display: 'none',
                },
            },
        },
    };
};

export const MobileTileGrid: StyleRule = ({
    theme,
    isArticleTile = false,
}) => ({
    gap: pxArrayToRem([isArticleTile ? 0 : 80, 6]),
    maxWidth: pxToRem(412),
    margin: pxArrayToRem([0, 1, 14, 1]),
    overflowX: 'hidden',

    ...PinTilesMobile(theme),
});

export const DesktopTileGrid: StyleRule = ({ theme }) => ({
    gap: pxArrayToRem([100, 20]),
    margin: pxArrayToRem([48, 48, 70, 51]),

    ...PinTilesDesktop(theme),

    [theme.screen.clamped]: {
        marginRight: 0,
    },
});
